export default class AuthView {
  constructor() {
    this.eventHandlers = {};
    this.currentForm = 'login';
  }

  async render() {
    return `
      <div id="page-auth" class="page-content active">
          <div class="login-register-page">
              <div class="auth-form" id="login-form">
                  <h2>Masuk ke HeliaEDU</h2>
                  <form>
                      <div class="form-group">
                          <label for="login-email">Email</label>
                          <input type="email" id="login-email" required placeholder="Masukkan email Anda" aria-describedby="login-email-help">
                          <div id="login-email-help" class="sr-only">Masukkan alamat email yang valid</div>
                      </div>
                      <div class="form-group password-group">
                          <label for="login-password">Password</label>
                          <div class="password-wrapper">
                              <input type="password" id="login-password" required placeholder="Masukkan password Anda" aria-describedby="login-password-help">
                              <button type="button" class="toggle-password" data-text_tip="Tampilkan password" data-hover_tip="left" data-dev_tip="desktop" aria-label="Tampilkan atau sembunyikan password">
                                  <span class="material-symbols-rounded">visibility</span>
                              </button>
                          </div>
                          <div id="login-password-help" class="sr-only">Masukkan password Anda</div>
                      </div>
                      <button type="submit" class="auth-btn" id="login-btn">Masuk</button>
                  </form>
                  <div class="auth-switch">
                      Belum punya akun? <button type="button" id="show-register">Daftar di sini</button>
                  </div>
                  <div class="guest-access">
                      <p>Atau lanjutkan tanpa akun:</p>
                      <button type="button" class="guest-btn" id="continue-guest">
                          <span class="material-symbols-rounded" aria-hidden="true">person</span>
                          Lanjutkan sebagai Tamu
                      </button>
                  </div>
              </div>

              <div class="auth-form" id="register-form" style="display: none;">
                  <h2>Daftar ke HeliaEDU</h2>
                  <form>
                      <div class="form-group">
                          <label for="register-name">Nama Lengkap</label>
                          <input type="text" id="register-name" required placeholder="Masukkan nama lengkap" aria-describedby="register-name-help">
                          <div id="register-name-help" class="sr-only">Masukkan nama lengkap Anda</div>
                      </div>
                      <div class="form-group">
                          <label for="register-email">Email</label>
                          <input type="email" id="register-email" required placeholder="Masukkan email Anda" aria-describedby="register-email-help">
                          <div id="register-email-help" class="sr-only">Masukkan alamat email yang valid</div>
                      </div>
                      <div class="form-group password-group">
                          <label for="register-password">Password</label>
                          <div class="password-wrapper">
                              <input type="password" id="register-password" required placeholder="Minimal 8 karakter" aria-describedby="register-password-help">
                              <button type="button" class="toggle-password" data-text_tip="Tampilkan password" data-hover_tip="left" data-dev_tip="desktop" aria-label="Tampilkan atau sembunyikan password">
                                  <span class="material-symbols-rounded">visibility</span>
                              </button>
                          </div>
                          <div id="register-password-help" class="sr-only">Password minimal 8 karakter</div>
                      </div>
                      <button type="submit" class="auth-btn" id="register-btn">Daftar</button>
                  </form>
                  <div class="auth-switch">
                      Sudah punya akun? <button type="button" id="show-login">Masuk di sini</button>
                  </div>
              </div>
          </div>
      </div>
    `;
  }

  async afterRender() {
    // Setup handled by presenter
  }

  setupFormEventListeners(onLogin, onRegister, onTogglePassword) {
    const loginForm = this.getLoginForm();
    const registerForm = this.getRegisterForm();
    
    if (loginForm) {
      this.eventHandlers.loginFormHandler = (e) => {
        e.preventDefault();
        const formData = this.getLoginFormData();
        onLogin(formData);
      };
      loginForm.addEventListener('submit', this.eventHandlers.loginFormHandler);
    }
    
    if (registerForm) {
      this.eventHandlers.registerFormHandler = (e) => {
        e.preventDefault();
        const formData = this.getRegisterFormData();
        onRegister(formData);
      };
      registerForm.addEventListener('submit', this.eventHandlers.registerFormHandler);
    }

    const toggleButtons = this.getAllTogglePasswordButtons();
    this.eventHandlers.togglePasswordHandlers = [];
    
    toggleButtons.forEach(btn => {
      const handler = (e) => {
        e.preventDefault();
        onTogglePassword(btn);
      };
      btn.addEventListener('click', handler);
      this.eventHandlers.togglePasswordHandlers.push({ element: btn, handler });
    });
  }

  setupNavigationEventListeners(onShowRegister, onShowLogin, onContinueAsGuest) {
    const showRegisterBtn = this.getShowRegisterButton();
    const showLoginBtn = this.getShowLoginButton();
    const continueGuestBtn = this.getContinueGuestButton();
    
    if (showRegisterBtn) {
      this.eventHandlers.showRegisterHandler = onShowRegister;
      showRegisterBtn.addEventListener('click', this.eventHandlers.showRegisterHandler);
    }
    
    if (showLoginBtn) {
      this.eventHandlers.showLoginHandler = onShowLogin;
      showLoginBtn.addEventListener('click', this.eventHandlers.showLoginHandler);
    }
    
    if (continueGuestBtn) {
      this.eventHandlers.continueGuestHandler = onContinueAsGuest;
      continueGuestBtn.addEventListener('click', this.eventHandlers.continueGuestHandler);
    }
  }

  showLoginForm() {
    const registerForm = this.getRegisterFormContainer();
    const loginForm = this.getLoginFormContainer();
    
    if (registerForm) registerForm.style.display = 'none';
    if (loginForm) loginForm.style.display = 'block';
    
    this.currentForm = 'login';
  }

  showRegisterForm() {
    const loginForm = this.getLoginFormContainer();
    const registerForm = this.getRegisterFormContainer();
    
    if (loginForm) loginForm.style.display = 'none';
    if (registerForm) registerForm.style.display = 'block';
    
    this.currentForm = 'register';
  }

  togglePasswordVisibility(button) {
    const input = this.getPasswordInputForButton(button);
    const icon = this.getIconForButton(button);
    
    if (!input || !icon) return;
    
    if (input.type === 'password') {
      input.type = 'text';
      icon.textContent = 'visibility_off';
      button.setAttribute('data-text_tip', 'Sembunyikan password');
    } else {
      input.type = 'password';
      icon.textContent = 'visibility';
      button.setAttribute('data-text_tip', 'Tampilkan password');
    }
  }

  setLoginButtonLoading(isLoading) {
    const button = this.getLoginButton();
    if (!button) return;

    if (isLoading) {
      button.disabled = true;
      button.textContent = 'Masuk...';
    } else {
      button.disabled = false;
      button.textContent = 'Masuk';
    }
  }

  setRegisterButtonLoading(isLoading) {
    const button = this.getRegisterButton();
    if (!button) return;

    if (isLoading) {
      button.disabled = true;
      button.textContent = 'Mendaftar...';
    } else {
      button.disabled = false;
      button.textContent = 'Daftar';
    }
  }

  getLoginFormData() {
    const emailInput = this.getLoginEmailInput();
    const passwordInput = this.getLoginPasswordInput();
    
    return {
      email: emailInput ? emailInput.value.trim() : '',
      password: passwordInput ? passwordInput.value : ''
    };
  }

  getRegisterFormData() {
    const nameInput = this.getRegisterNameInput();
    const emailInput = this.getRegisterEmailInput();
    const passwordInput = this.getRegisterPasswordInput();
    
    return {
      name: nameInput ? nameInput.value.trim() : '',
      email: emailInput ? emailInput.value.trim() : '',
      password: passwordInput ? passwordInput.value : ''
    };
  }

  clearLoginForm() {
    const emailInput = this.getLoginEmailInput();
    const passwordInput = this.getLoginPasswordInput();
    
    if (emailInput) emailInput.value = '';
    if (passwordInput) passwordInput.value = '';
  }

  clearRegisterForm() {
    const nameInput = this.getRegisterNameInput();
    const emailInput = this.getRegisterEmailInput();
    const passwordInput = this.getRegisterPasswordInput();
    
    if (nameInput) nameInput.value = '';
    if (emailInput) emailInput.value = '';
    if (passwordInput) passwordInput.value = '';
  }

  prefillLoginEmail(email) {
    const emailInput = this.getLoginEmailInput();
    if (emailInput) {
      emailInput.value = email;
    }
  }

  // Helper methods untuk DOM queries
  getLoginForm() {
    return document.querySelector('#login-form form');
  }

  getRegisterForm() {
    return document.querySelector('#register-form form');
  }

  getLoginFormContainer() {
    return document.querySelector('#login-form');
  }

  getRegisterFormContainer() {
    return document.querySelector('#register-form');
  }

  getLoginEmailInput() {
    return document.querySelector('#login-email');
  }

  getLoginPasswordInput() {
    return document.querySelector('#login-password');
  }

  getRegisterNameInput() {
    return document.querySelector('#register-name');
  }

  getRegisterEmailInput() {
    return document.querySelector('#register-email');
  }

  getRegisterPasswordInput() {
    return document.querySelector('#register-password');
  }

  getLoginButton() {
    return document.querySelector('#login-btn');
  }

  getRegisterButton() {
    return document.querySelector('#register-btn');
  }

  getShowRegisterButton() {
    return document.querySelector('#show-register');
  }

  getShowLoginButton() {
    return document.querySelector('#show-login');
  }

  getContinueGuestButton() {
    return document.querySelector('#continue-guest');
  }

  getAllTogglePasswordButtons() {
    return Array.from(document.querySelectorAll('.toggle-password') || []);
  }

  getPasswordInputForButton(button) {
    return button.previousElementSibling;
  }

  getIconForButton(button) {
    return button.querySelector('.material-symbols-rounded');
  }

  cleanupEventListeners() {
    const loginForm = this.getLoginForm();
    const registerForm = this.getRegisterForm();
    
    if (loginForm && this.eventHandlers.loginFormHandler) {
      loginForm.removeEventListener('submit', this.eventHandlers.loginFormHandler);
    }
    
    if (registerForm && this.eventHandlers.registerFormHandler) {
      registerForm.removeEventListener('submit', this.eventHandlers.registerFormHandler);
    }

    if (this.eventHandlers.togglePasswordHandlers) {
      this.eventHandlers.togglePasswordHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
      });
      this.eventHandlers.togglePasswordHandlers = [];
    }

    const showRegisterBtn = this.getShowRegisterButton();
    const showLoginBtn = this.getShowLoginButton();
    const continueGuestBtn = this.getContinueGuestButton();
    
    if (showRegisterBtn && this.eventHandlers.showRegisterHandler) {
      showRegisterBtn.removeEventListener('click', this.eventHandlers.showRegisterHandler);
    }
    
    if (showLoginBtn && this.eventHandlers.showLoginHandler) {
      showLoginBtn.removeEventListener('click', this.eventHandlers.showLoginHandler);
    }
    
    if (continueGuestBtn && this.eventHandlers.continueGuestHandler) {
      continueGuestBtn.removeEventListener('click', this.eventHandlers.continueGuestHandler);
    }

    this.eventHandlers = {};
  }

  cleanup() {
    this.cleanupEventListeners();
  }
}